Namespace 'CustomerVisualMode.Mappers'

class CustomerVisualMode.Mappers.IncludedValueSetMapper
  constructor: (primaryKey, secondaryKey, noValuesIdentifier, allValuesIdentifier) ->
    @VALUES_TYPE = CustomerVisualMode.Mappers.ValuesMapper.TYPE
    @ALL_TYPE = CustomerVisualMode.Mappers.AllValuesMapper.TYPE
    @NONE_TYPE = CustomerVisualMode.Mappers.NoneValuesMapper.TYPE
    @primaryKey = primaryKey
    @secondaryKey = secondaryKey
    @noValuesIdentifier = noValuesIdentifier
    @allValuesIdentifier = allValuesIdentifier
    @mappers = [
      new CustomerVisualMode.Mappers.AllValuesMapper(allValuesIdentifier),
      new CustomerVisualMode.Mappers.NoneValuesMapper(noValuesIdentifier),
      new CustomerVisualMode.Mappers.ValuesMapper(primaryKey, secondaryKey)
    ]

  mapToCompositeFilter: (intelligentGroups) ->
    return {} unless @_hasValidValues(intelligentGroups)

    type = @_type(intelligentGroups)
    mapper = _.find(@mappers, (mapper) -> mapper.canHandle(type))
    mapper.mapToCompositeFilter(intelligentGroups)

  mapToSearchQuery: (intelligentGroups) ->
    included = intelligentGroups.included
    return {} unless included

    mapper = _.find(@mappers, (mapper) -> mapper.canHandle(included.type))
    mapper.mapToSearchQuery(intelligentGroups)

  _hasValidValues: (values) ->
    values[@primaryKey]?.length > 0 || values[@secondaryKey]?.length > 0

  _type: (intelligentGroups) ->
    primary = intelligentGroups[@primaryKey]
    return @ALL_TYPE if primary && primary.includes(@allValuesIdentifier)
    return @NONE_TYPE if primary && primary.includes(@noValuesIdentifier)
    @VALUES_TYPE
